<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      :class="{
        opened: opened.indexOf('newUser') >= 0,
        'last-active': opened.indexOf('newUser') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runSave()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozit") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="customer">
          {{ $t("novyUzivatel") }} {{ $t("kZakaznikovi") }}
          {{ customer.customerName }}
        </h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.project" class="text-danger">
          {{ errors.project }}
        </div>
        <div class="my-4">
          <div class="side-box__row d-flex align-items-center mt-3">
            <span
              :class="{
                'side-box__content__label--bottom': $translated('info_user_firstname')
              }"
              class="side-box__content__label"
            >
              {{ $t("jmeno") }}
            </span>

            <div class="side-box__content__wrapper">
              <div
                :class="{
                  'has-error': error.firstName,
                  disabled: false
                }"
                class="side-box__content__input custom-control__custom-input ml-3"
              >
                <span v-if="!newUser.firstName" class="placeholder">{{ $t("zadejteJmeno") }}</span>
                <input
                  v-model="newUser.firstName"
                  autofocus
                  class="w-100"
                  maxlength="40"
                  minlength="1"
                  placeholder=""
                  type="text"
                  @blur="validateFirstName()"
                />
              </div>

              <InfoExclamationMark
                :info-text="'info_user_firstname'"
                :info-tooltip="'tooltip_user_firstname'"
                class="offset-left"
              />
            </div>
          </div>
          <div class="side-box__row d-flex align-items-center mt-3">
            <span
              :class="{
                'side-box__content__label--bottom': $translated('info_user_lastname')
              }"
              class="side-box__content__label"
            >
              {{ $t("prijmeni") }}
            </span>
            <div class="side-box__content__wrapper">
              <div
                :class="{
                  'has-error': error.lastName,
                  disabled: false
                }"
                class="side-box__content__input custom-control__custom-input ml-3"
              >
                <span v-if="!newUser.lastName" class="placeholder">{{ $t("zadejtePrijmeni") }}</span>
                <input
                  v-model="newUser.lastName"
                  autofocus
                  class="w-100"
                  maxlength="40"
                  minlength="1"
                  placeholder=""
                  type="text"
                  @blur="validateLastName()"
                />
              </div>

              <InfoExclamationMark
                :info-text="'info_user_lastname'"
                :info-tooltip="'tooltip_user_lastname'"
                class="offset-left"
              />
            </div>
          </div>
          <div class="side-box__row d-flex align-items-center mt-3">
            <span
              :class="{
                'side-box__content__label--bottom': $translated('info_user_phone')
              }"
              class="side-box__content__label"
            >
              {{ $t("phone") }}
            </span>

            <div class="side-box__content__wrapper">
              <div
                :class="{
                  'has-error': error.phone,
                  disabled: false
                }"
                class="side-box__content__input custom-control__custom-input ml-3"
              >
                <span v-if="!newUser.phone" class="placeholder">{{ $t("zadejteTelefon") }}</span>
                <input
                  v-model="newUser.phone"
                  autofocus
                  class="w-100"
                  maxlength="15"
                  placeholder=""
                  type="text"
                  @blur="validatePhone()"
                />
              </div>

              <InfoExclamationMark
                :info-text="'info_user_phone'"
                :info-tooltip="'tooltip_user_phone'"
                class="offset-left"
              />
            </div>
          </div>
          <div class="side-box__row d-flex align-items-center mt-3">
            <span
              :class="{
                'side-box__content__label--bottom': $translated('info_user_email')
              }"
              class="side-box__content__label"
            >
              {{ $t("email") }}
            </span>
            <div class="side-box__content__wrapper">
              <div
                :class="{
                  'has-error': error.email,
                  disabled: false
                }"
                class="side-box__content__input custom-control__custom-input ml-3"
              >
                <span v-if="!newUser.email" class="placeholder">{{ $t("zadejteEmail") }}</span>
                <input
                  v-model="newUser.email"
                  autofocus
                  class="w-100"
                  maxlength="60"
                  placeholder=""
                  type="text"
                  @blur="validateEmail()"
                />
              </div>
              <InfoExclamationMark
                :info-text="'info_user_email'"
                :info-tooltip="'tooltip_user_email'"
                class="offset-left"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleConfirmation"
      @no="closeBox('newUser')"
      @yes="runSave()"
    />
    <InfoConfirmationModal
      :opened="openedInfoConfirmation"
      :text="'requestReceived202'"
      @close="toggleConfirmation"
      @no="closeBox('newUser')"
      @yes="closeBox('newUser')"
    />

    <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
  </div>
</template>

<script>
import axios from "axios"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import InfoExclamationMark from "@/components/info/infoExclamationMark.vue"
import InfoConfirmationModal from "@/components/confirmations/info.vue"
import { useCustomerStore } from "@/store/modules/customer"

export default {
  components: {
    SaveConfirmationModal,
    InfoConfirmationModal,
    ErrorModal,
    InfoExclamationMark
  },
  props: {
    opened: Array
  },
  setup() {
    const customerStore = useCustomerStore()

    return { customerStore }
  },
  data() {
    return {
      formValidationErrors: [],
      newUser: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        attributes: {
          language: "CZ"
        }
      },
      errors: {
        project: ""
      },
      error: {
        firstName: false,
        lastName: false,
        phone: false,
        email: false
      },
      openedError: false,
      errorsToTranslate: [],
      openedConfirmation: false,
      openedInfoConfirmation: false,
      openedSuccessWaiting: false,
      openedSuccess: false,
      selectedCustomer: {}
    }
  },
  computed: {
    customer() {
      return this.customerStore.selectedCustomer
    },
    customers() {
      return this.customerStore.customerList
    }
  },
  watch: {
    customers() {}
  },
  mounted() {},
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === "newUser") {
        this.$emit("closeBox", box)
      } else {
        this.errors.endpoint = ""
        this.$emit("closeBox", box)
      }
    },
    validateFirstName() {
      if (this.newUser.firstName == "") {
        this.error.firstName = true
      } else {
        this.error.firstName = false
      }
    },
    validateLastName() {
      console.log("validateLastName")
      if (this.newUser.lastName == "") {
        this.error.lastName = true
      } else {
        this.error.lastName = false
      }
    },
    validatePhone() {
      if (this.newUser.phone == "" || !this.isPhoneValid()) {
        this.error.phone = true
      } else {
        this.error.phone = false
      }
    },
    validateEmail() {
      if (this.newUser.email == "" || !this.isEmailValid()) {
        this.error.email = true
      } else {
        this.error.email = false
      }
    },
    async runSave() {
      this.validateFirstName()
      this.validateLastName()
      this.validatePhone()
      this.validateEmail()
      if (
        this.newUser.firstName == "" ||
        this.newUser.lastName == "" ||
        this.newUser.email == "" ||
        this.newUser.phone == ""
      ) {
        this.errors.project = this.$t("vyplnteOznacenaPole")
        return
      }

      if (!this.isPhoneValid()) {
        this.errors.project = this.$t("TelefonVeSpatnemTvaru")
        return
      }

      if (!this.isEmailValid()) {
        this.errors.project = this.$t("EmailVeSpatnemTvaru")
        return
      }

      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))

      this.errorsToTranslate = []
      this.errors.project = ""
      let created = await this.createUser()

      this.$store.commit("modals/setWaitingLoader", "")

      if (created) {
        //this.$emit("reloadProjects");
        if (this.errorsToTranslate.length > 0) {
          this.openedError = true
        } else if (!this.openedInfoConfirmation) {
          this.closeBox("newUser")
        }
      }
    },
    createUser() {
      let notifications = []

      return axios
        .post(`${process.env.VUE_APP_API}/users/customers/${this.customer.customerId}`, this.newUser)
        .then((response) => {
          if (response.status == 202) {
            /*
            notifications.push({
              text: "requestReceived202",
              error: false
            });
            */
            this.openedInfoConfirmation = true
            this.$store.commit("modals/setGlobalNotification", notifications)
          } else if (response.status == 201) {
            notifications.push({
              text: "requestProcessed201",
              error: false
            })
            this.$store.commit("modals/setGlobalNotification", notifications)
          }
          return true
        })
        .catch((error) => {
          this.errorsToTranslate.push(error.data)
          //this.openedError = true;
          return true
        })
    },
    toggleConfirmation() {
      this.openedConfirmation = this.openedConfirmation ? false : true
    },
    selectCustomer(customer) {
      this.selectedCustomer = customer
    },
    isEmailValid: function () {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (re.test(String(this.newUser.email).toLowerCase())) {
        return true
      } else {
        return false
      }
    },
    isPhoneValid: function () {
      const re = /^\+[0-9]{10,14}$/
      if (re.test(String(this.newUser.phone))) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.offset-left {
  padding-left: 20px;
}
</style>
